import React, { useEffect, useState } from "react";
import { http, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Download, Database, Users, Home as HomeIcon, ClipboardList } from "lucide-react";

export default function AdminExport() {
  const [snap, setSnap] = useState(null);
  const [busy, setBusy] = useState(false);

  const downloadJSON = (data, filename) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };

  const preview = async () => {
    setBusy(true);
    try { const { data } = await http.get("/admin/export/full"); setSnap(data); toast.success("Snapshot geladen"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const downloadFull = async () => {
    setBusy(true);
    try {
      const { data } = await http.get("/admin/export/full");
      downloadJSON(data, `woonverder-full-clone-${new Date().toISOString().slice(0, 10)}.json`);
      toast.success("Volledige clone gedownload");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const downloadOne = async (col) => {
    try { const { data } = await http.get(`/admin/export/${col}`); downloadJSON(data, `woonverder-${col}-${new Date().toISOString().slice(0, 10)}.json`); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  useEffect(() => { preview(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-10">
      <p className="text-xs font-bold uppercase tracking-widest text-[color:var(--wv-green-dark)]">Owner</p>
      <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[color:var(--wv-obsidian)] mt-2">Data Export & Full Clone</h1>
      <p className="mt-3 text-slate-600 max-w-3xl">Volledige snapshot van het platform: woningen, foto's, gebruikers, verkopers, kopers en zoekprofielen. Gebruik dit om later te migreren naar uw eigen servers.</p>

      <div className="mt-8 grid md:grid-cols-4 gap-3">
        {[["properties", HomeIcon], ["users", Users], ["buyer_profiles", ClipboardList], ["full", Database]].map(([k, Ic]) => (
          <div key={k} className="p-5 rounded-2xl bg-white border border-slate-200">
            <Ic className="w-5 h-5 text-[color:var(--wv-green)]" />
            <p className="mt-2 text-xs uppercase font-bold tracking-wider text-slate-500">{k.replace("_", " ")}</p>
            <p className="font-mono-num text-2xl font-extrabold mt-1">{k === "full" ? snap?.counts && Object.values(snap.counts).reduce((a, b) => a + b, 0) : snap?.counts?.[k] ?? "—"}</p>
            <button onClick={() => k === "full" ? downloadFull() : downloadOne(k)} className="mt-3 wv-btn-outline text-xs w-full inline-flex items-center justify-center gap-1" data-testid={`export-${k}`}><Download className="w-3.5 h-3.5" /> Download JSON</button>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <button onClick={downloadFull} disabled={busy} className="wv-btn-primary inline-flex items-center gap-2" data-testid="export-full-btn">
          <Download className="w-4 h-4" /> Download volledige clone (alles-in-één)
        </button>
      </div>

      <div className="mt-10 p-5 rounded-2xl bg-[color:var(--wv-obsidian)] text-white">
        <p className="text-xs font-bold uppercase tracking-widest text-white/60">Veiligheid</p>
        <p className="mt-2 text-sm text-white/85">Deze pagina is uitsluitend toegankelijk voor admin-accounts. Wachtwoorden worden nooit meegenomen in de export. De export bevat wel foto's als base64 data URLs — bewaar het bestand veilig.</p>
      </div>
    </div>
  );
}
